import styled from 'styled-components'
import ModalActions from 'components/ModalActions/ModalActions'

export const StyledModalActions = styled(ModalActions)`
  margin-top: 24px;
`
